(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elmayorista-header-drawer"] && !Shopify.designMode) return;
  try {
    const initCuratedDrawers = () => {
    document.querySelectorAll('.em-curated-drawer #Details-menu-drawer-container').forEach((details) => {
      if (details.dataset.emCuratedDrawerReady === 'true') return;
      details.dataset.emCuratedDrawerReady = 'true';

      const summary = details.querySelector('.header__icon--menu');
      const drawer = details.querySelector('.menu-drawer');
      const backdrop = details.querySelector('.menu-drawer__backdrop');
      const closeControls = details.querySelectorAll('.em-curated-drawer__close, .menu-drawer__backdrop');
      const syncState = () => {
        const isOpen = details.hasAttribute('open');
        details.classList.toggle('menu-open', isOpen);
        summary?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (drawer) {
          drawer.getAnimations().forEach((animation) => animation.cancel());

          if (isOpen) {
            drawer.style.setProperty('transform', 'translateX(0)', 'important');
            drawer.style.setProperty('visibility', 'visible', 'important');
            drawer.style.setProperty('opacity', '1', 'important');
          } else {
            drawer.style.removeProperty('transform');
            drawer.style.removeProperty('visibility');
            drawer.style.removeProperty('opacity');
          }
        }

        if (backdrop) {
          if (isOpen) {
            backdrop.style.setProperty('opacity', '1', 'important');
            backdrop.style.setProperty('pointer-events', 'auto', 'important');
          } else {
            backdrop.style.removeProperty('opacity');
            backdrop.style.removeProperty('pointer-events');
          }
        }
      };

      details.addEventListener('toggle', syncState);
      summary?.addEventListener('click', () => {
        window.setTimeout(syncState, 0);
        window.setTimeout(syncState, 120);
      });
      new MutationObserver(syncState).observe(details, {
        attributes: true,
        attributeFilter: ['open', 'class'],
      });
      closeControls.forEach((control) => {
        control.addEventListener('click', () => {
          details.removeAttribute('open');
          syncState();
        });
      });
      details.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          details.removeAttribute('open');
          syncState();
          summary?.focus();
        }
      });

      syncState();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCuratedDrawers);
  } else {
    initCuratedDrawers();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elmayorista-header-menu"] && !Shopify.designMode) return;
  try {
    const initCuratedMenus = () => {
    document.querySelectorAll('[data-em-curated-menu]').forEach((menu) => {
      if (menu.dataset.emCuratedReady === 'true') return;
      menu.dataset.emCuratedReady = 'true';
      const groups = [...menu.querySelectorAll('.em-curated-menu__group')];
      const closeTimers = new WeakMap();
      const canHover = () => window.matchMedia('(hover: hover)').matches;
      const closeDelay = 1200;
      const closeOthers = (active) => groups.forEach((group) => {
        if (group !== active) group.removeAttribute('open');
      });
      const cancelClose = (group) => {
        const timer = closeTimers.get(group);
        if (timer) window.clearTimeout(timer);
        closeTimers.delete(group);
      };
      const scheduleClose = (group) => {
        cancelClose(group);
        closeTimers.set(group, window.setTimeout(() => {
          if (!group.matches(':hover') && !group.matches(':focus-within')) {
            group.removeAttribute('open');
          }
          closeTimers.delete(group);
        }, closeDelay));
      };
      groups.forEach((group) => {
        const panel = group.querySelector('.em-curated-menu__panel');

        group.addEventListener('toggle', () => {
          if (group.open) {
            cancelClose(group);
            closeOthers(group);
          }
        });
        group.addEventListener('pointerenter', () => {
          if (canHover()) {
            cancelClose(group);
            closeOthers(group);
            group.setAttribute('open', '');
          }
        });
        group.addEventListener('pointerleave', () => {
          if (canHover()) {
            scheduleClose(group);
          }
        });
        group.addEventListener('focusin', () => {
          cancelClose(group);
          closeOthers(group);
          group.setAttribute('open', '');
        });
        group.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!group.matches(':focus-within')) group.removeAttribute('open');
          }, 0);
        });
        panel?.addEventListener('pointerenter', () => cancelClose(group));
        panel?.addEventListener('pointerleave', () => {
          if (canHover()) scheduleClose(group);
        });
      });
      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target)) groups.forEach((group) => group.removeAttribute('open'));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCuratedMenus);
  } else {
    initCuratedMenus();
  }
  } catch(e) { console.error(e); }
})();

})();
